import { render, staticRenderFns } from "./AppointmentForm.vue?vue&type=template&id=9b2b224c&scoped=true"
import script from "./AppointmentForm.vue?vue&type=script&lang=js"
export * from "./AppointmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2b224c",
  null
  
)

export default component.exports